import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const featuresPage = PageBlueprint.make({
  name: 'features',
  params: {
    path: '/features',
    loader: () =>
      import('./components/FeatureExplorerPage').then(m => (
        <m.FeatureExplorerPage />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'feature',
  extensions: [featuresPage],
});
